import type { AppConfig } from "../../types/appConfig";
import { assertResponseOk, expectStatuses, fetchZekay } from "../zekay/httpClient";
import type { QualificationItem } from "./Qualification.typed";

export class QualificationModel {
  zekayAPI: string;

  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }

  async getQualificationsList(): Promise<string[]> {
    const r = await fetchZekay(this.zekayAPI + "/qualifications");
    await expectStatuses(r, 200, 204);
    if (r.status === 204) return [];
    return (await r.json()) as string[];
  }

  async listQualificationItems(): Promise<QualificationItem[]> {
    const response = await fetchZekay(`${this.zekayAPI}/qualifications/items`);
    await expectStatuses(response, 200, 204);
    if (response.status === 204) return [];
    return (await response.json()) as QualificationItem[];
  }

  async createQualificationItem(payload: {
    sigle: string;
    name?: string;
    description?: string;
  }): Promise<QualificationItem> {
    const body = {
      sigle: (payload.sigle ?? "").trim(),
      name: (payload.name ?? "").trim() || undefined,
      description: (payload.description ?? "").trim() || undefined,
    };
    const response = await fetchZekay(`${this.zekayAPI}/qualifications/items`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    await expectStatuses(response, 201);
    return (await response.json()) as QualificationItem;
  }

  async updateQualificationItem(
    id: number,
    payload: { sigle: string; name?: string; description?: string },
  ): Promise<QualificationItem> {
    const body = {
      sigle: (payload.sigle ?? "").trim(),
      name: (payload.name ?? "").trim() || undefined,
      description: (payload.description ?? "").trim() || undefined,
    };
    const response = await fetchZekay(`${this.zekayAPI}/qualifications/items/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    await assertResponseOk(response);
    return (await response.json()) as QualificationItem;
  }

  async deleteQualificationItem(id: number): Promise<void> {
    const response = await fetchZekay(`${this.zekayAPI}/qualifications/items/${id}`, {
      method: "DELETE",
    });
    await expectStatuses(response, 204);
  }
}
